export function dateToFrench(date: string) {
    const dateObj = new Date(date);
    const day = dateObj.toLocaleString('fr-FR', { weekday: 'long' });
    const dayNumber = dateObj.toLocaleString('fr-FR', { day: 'numeric' });
    const month = dateObj.toLocaleString('fr-FR', { month: 'long' });
    const dayUper = day.charAt(0).toUpperCase() + day.slice(1);
    return `${dayUper} ${dayNumber} ${month}`;
}

export function dateToFrenchWithHours(date: string) {
    const dateObj = new Date(date);

    const day = dateObj.toLocaleString('fr-FR', { weekday: 'long' });
    const dayNumber = dateObj.getDate();
    const month = dateObj.toLocaleString('fr-FR', { month: 'long' });

    const hours = dateObj.getHours().toString().padStart(2, '0');
    const minutes = dateObj.getMinutes().toString().padStart(2, '0');

    const dayUper = day.charAt(0).toUpperCase() + day.slice(1);

    return `${dayUper} ${dayNumber} ${month}, ${hours}H${minutes}`;
}

export function dateToFrenchShort(date: string) {
    const dateObj = new Date(date);

    const options: any = {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
        timeZone: 'UTC',
    };

    const formattedDate = dateObj.toLocaleDateString('fr-FR', options);

    return formattedDate;
}

export function formatHours(date: string) {
    const dateObj = new Date(date);
    const hours = dateObj.toLocaleString('fr-FR', { hour: 'numeric' });
    const minutes = dateObj.toLocaleString('fr-FR', { minute: 'numeric' });
    return `${hours}${minutes}`.replace(' ', '');
}
